
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M16.255 12.9827L14.4712 11.1989L19.8227 5.84732C20.3579 5.31216 21.0714 5.31216 21.6066 5.84732C22.1418 6.38248 22.1418 7.09602 21.6066 7.63117L16.255 12.9827Z"></path><path d="M11.5279 13.4287C12.2414 12.7152 13.3117 12.7152 14.0253 13.4287C14.7388 14.1423 14.7388 15.2126 14.0253 15.9261C13.4009 16.6397 10.9035 16.5505 10.9035 16.5505C10.9035 16.5505 10.8143 14.0531 11.5279 13.4287Z"></path><path d="M19 4.36842V2H11H3V22H19V14.1053"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiDesign",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
